
<br>
<form>
  <div class="row">
    <div class="form-group col-4">
      <label for="startdate">Date de début de période</label>
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd" name="startdate" [(ngModel)]="filterParams.startdate"
          ngbDatepicker #d1="ngbDatepicker" (dateSelect)="checkDate()" (click)="d1.toggle()">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btn-grey" (click)="d1.toggle()" type="button"><i
              class="fa fa-calendar"></i></button>
        </div>
      </div>
    </div>
    <div class="form-group col-4">
      <label for="stopdate">Date de fin</label>
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd" name="stopdate" [(ngModel)]="filterParams.stopdate"
          ngbDatepicker #d2="ngbDatepicker" (dateSelect)="checkDate()" (click)="d2.toggle()">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btn-grey" (click)="d2.toggle()" type="button"><i
              class="fa fa-calendar"></i></button>
        </div>
      </div>
    </div>
    <div class="form-group col-4">
      <button class="btn" style="margin-top: 32px;"
      [ngClass]="{'btn-success blink':dateChanged, 'btn-info': !dateChanged}"
      (click)="applyFilters()">Rechercher</button>
    </div>
  </div>

</form>
<br>

<div class="clearfix">
  <form class="inline">
    <button type="button" (click)="Export('TEXT')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Copy</button>
    <button type="button" (click)="Export('CSV')" class="btn btn-sm btn-outline-secondary ml-2 h-100">CSV</button>
    <button type="button" (click)="Export('EXCEL')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Excel</button>
    <button type="button" (click)="Export('PRINT')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Print</button>

    <div class="form-group form-inline ml-auto">
      Recherche: <input class="form-control ml-2" type="text" name="searchTerm"
        [(ngModel)]="pagingService.searchTerm" />
    </div>
  </form>


  <table id="selectedColumn" class="table table-bordered table-striped table-hover table-sm" cellspacing="0"
    width="100%">
    <thead>
      <tr>
        <th class="th" sortable="id" (sort)="onSort($event)">ID</th>
        <th class="th" sortable="name" (sort)="onSort($event)">Intitulé</th>
        <th class="th collapsible" sortable="stage" (sort)="onSort($event)">Type</th>
        <th class="th collapsible" sortable="date_debut" (sort)="onSort($event)">Date début</th>
        <th class="th collapsible" sortable="dates" (sort)="onSort($event)">Dates</th>
        <th class="th collapsible" sortable="nbparticipants" (sort)="onSort($event)">#inscrits</th>
        <th class="th" sortable="nbreponses" (sort)="onSort($event)">#réponses</th>
        <th class="th" sortable="nbyes" (sort)="onSort($event)">#OUI</th>
        <th class="th" sortable="nbno" (sort)="onSort($event)">#NON</th>
        <th class="th"></th>
      </tr>
    </thead>
    @if (initialized) {
<tbody>
      @for (f of formations$ | async; track f) {
<tr>
        <td>{{f.id}}</td>
        <td>
          <ngb-highlight [result]="f.name" [term]="pagingService.searchTerm"></ngb-highlight>
        </td>
        <td class="collapsible">
            <ngb-highlight [result]="f.stage" [term]="pagingService.searchTerm">
            </ngb-highlight>
          </td>
        <td class="collapsible">
            <ngb-highlight [result]="f.date_debut" [term]="pagingService.searchTerm">
            </ngb-highlight>
          </td>
          <td class="collapsible">
              <ngb-highlight [result]="f.dates" [term]="pagingService.searchTerm">
              </ngb-highlight>
            </td>
        <td class="collapsible">
          <ngb-highlight [result]="f.nbparticipants" [term]="pagingService.searchTerm">
          </ngb-highlight>
        </td>
        <td class="collapsible">
          <ngb-highlight [result]="f.nbreponses" [term]="pagingService.searchTerm">
          </ngb-highlight>
        </td>
        <td class="collapsible">
          <ngb-highlight [result]="f.nbyes" [term]="pagingService.searchTerm">
          </ngb-highlight>
        </td>
        <td class="collapsible">
            <ngb-highlight [result]="f.nbno" [term]="pagingService.searchTerm">
            </ngb-highlight>
          </td>
        <td>
          <div class="inline">
            <button type="button" title="Voir les détails" (click)="selectFormation(f)"
              class="btn btn-sm btn-primary mr-2 w30"><i class="fa fa-list"></i></button>
          </div>
        </td>
      </tr>
}
    </tbody>
}
  </table>

  <div class="inline">
    <div class="">
      Total: {{(total$ | async)}}
    </div>
    <div class="ml-auto">
      <ngb-pagination class="d-flex justify-content-end" [collectionSize]="total$ | async" [(page)]="pagingService.page"
        [boundaryLinks]="true" [rotate]="true" [directionLinks]="true" [pageSize]="pagingService.pageSize" [maxSize]="3"
        name="page">
      </ngb-pagination>
    </div>
  </div>

</div>
